import { fmt } from "./ui-kit";
import React, { useEffect, useState } from "react";
import api, { apiError } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { ShieldCheck, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

const STATEMENTS = [
  ["workforce_trained", "All workforce members with access to client information have completed HIPAA privacy & security training."],
  ["policies_in_place", "Our agency maintains written privacy, security, breach-notification and minimum-necessary policies."],
  ["mfa_enforced", "Every staff account uses two-step sign-in (authenticator) and shared logins are prohibited."],
];

export function HipaaAttestation({ companyId }) {
  const [rec, setRec] = useState(undefined);
  const [f, setF] = useState({ name: "", title: "", note: "", workforce_trained: false, policies_in_place: false, mfa_enforced: false });
  useEffect(() => { api.get(`/companies/${companyId}/setup-checklist`).then((r) => setRec(r.data.hipaa_attestation)).catch(() => setRec(null)); }, [companyId]);
  const ok = f.name.trim().length > 1 && f.title.trim().length > 1 && STATEMENTS.every(([k]) => f[k]);
  const submit = async () => {
    try { const { data } = await api.post(`/companies/${companyId}/hipaa-attestation`, { ...f, attested: true }); setRec(data); toast.success("HIPAA readiness attestation recorded"); }
    catch (e) { toast.error(apiError(e)); }
  };
  if (rec === undefined) return null;
  return (
    <div className="space-y-3 rounded-2xl border border-border bg-card p-6 text-sm" data-testid="hipaa-attestation">
      <div className="flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-primary" /><h2 className="font-head text-lg font-bold">HIPAA readiness attestation</h2></div>
      {rec ? (
        <div className="rounded-xl bg-[#DEF1E5]/50 p-3" data-testid="hipaa-attested">
          <p className="flex items-center gap-2 font-semibold text-primary"><CheckCircle2 className="h-4 w-4" /> Attested by {rec.name}, {rec.title}</p>
          <p className="text-xs text-muted-foreground">{fmt(rec.attested_at)} · {rec.by}{rec.note ? ` · ${rec.note}` : ""}. Re-attest any time after policy or staffing changes.</p>
          <Button size="sm" variant="ghost" className="mt-2" onClick={() => setRec(null)} data-testid="hipaa-reattest">Re-attest</Button>
        </div>
      ) : (
        <>
          <p className="text-muted-foreground">An agency administrator confirms the following before live client data. This is your agency's own attestation (not a certification by Airfistuus) and is recorded in the audit log.</p>
          <ul className="space-y-2">{STATEMENTS.map(([k, label]) => <li key={k}><label className="flex items-start gap-2"><input type="checkbox" className="mt-1" checked={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.checked })} data-testid={`hipaa-${k}`} /><span>{label}</span></label></li>)}</ul>
          <div className="grid gap-3 sm:grid-cols-3">
            <Input placeholder="Signatory name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="hipaa-name" />
            <Input placeholder="Title (e.g. Privacy Officer)" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="hipaa-title" />
            <Input placeholder="Note (optional)" value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} data-testid="hipaa-note" />
          </div>
          <Button disabled={!ok} onClick={submit} data-testid="hipaa-submit">Record attestation</Button>
        </>
      )}
    </div>
  );
}
